export default "__VITE_ASSET__BSLOscHo__"